import React from 'react';

export const AUTH_GENERIC_FAILED =
  'Authentication failed. Token may be invalid or expired,\
  please log in again.';

export const JOB_NOT_FOUND = 'Requested job was not found';

export const SERVER_CONNECTED_HOVERTEXT = 'Live updates on';
export const SERVER_DISCONNECTED_HOVERTEXT = 'Live updates off';

export const PROFILE_HOVERTEXT = 'User Profile Settings';
export const ACCESS_SETTINGS_TEXT = 'Log in to access User Profile';

export const NO_DATA_AVAILABLE = 'No data is available';

export const NOTIFICATION_SUCCESS = 'Subscription was modified';
export const NOTIFICATION_FAILURE = 'Subscription was not modified';

export const RETRIGGER_SUCCESS = 'Retrigger was successful.';

export const PROFILE_CRON_POPOVER_BODY = (
  <div>
    Traditional cron format consists of <b>five
      fields separated by white spaces</b>: <br />
    Minute<br />
    Hour<br />
    Day_of_the_Month<br />
    Month_of_the_Year<br />
    Day_of_the_Week<br /><br />
    Any of these fields may be an asterisk (*) for field's full range of
    possible values. Any field may contain a list of values separated
    by commas, (e.g. 1,3,7) or a range
    (two integers separated by a hyphen, e.g. 1-5). <br /><br />
    After an asterisk (*) or a range of values, you can use character / to specify
    that values are repeated over and over with a certain interval between them:
    value "*/4" in Minute field means that the action should be performed every 4 minutes
    <br /><br />
    Examples:<br />
    0 17 * * * Daily at 5pm<br />
    0 */1 * * * Every hour<br />
    0 9 * * 1-5 Every weekday at 9am
  </div>
);

export const PROFILE_TRIGGER_POPOVER_BODY = (
  <div>
    Comma separated values entered here are compared as a whitelist against the text
    in the TRIGGERED_BY parameter used when a dispatcher was built.<br /><br />
    You will only receive notifications for jobs whose dispatcher TRIGGERED_BY
    text <b>contains</b> any of the filter values (case insensitive).
  </div>
);

export const DRAG_MULTISELECT_POPOVER_BODY = (
  <div>
    Holding the designated key throughout your selection will keep your
    previously selected elements.

    This is also helpful when having to click outside the table!
  </div>
);


// WEBPACK FOOTER //
// src/helpers/messaging.js